"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllSettlements = exports.getSettlements = void 0;
const http_1 = require("../../utils/http");
const settlementsEndpoint = 'settlements';
/**
 * Get amount of sent and received from settlements with a peer
 *
 * @param requestOptions Options for making requests
 * @param peer  Swarm address of peer
 */
async function getSettlements(requestOptions, peer) {
    const response = await (0, http_1.http)(requestOptions, {
        url: `${settlementsEndpoint}/${peer}`,
        responseType: 'json',
    });
    return response.data;
}
exports.getSettlements = getSettlements;
/**
 * Get settlements with all known peers and total amount sent or received
 *
 * @param requestOptions Options for making requests
 */
async function getAllSettlements(requestOptions) {
    const response = await (0, http_1.http)(requestOptions, {
        url: settlementsEndpoint,
        responseType: 'json',
    });
    return response.data;
}
exports.getAllSettlements = getAllSettlements;
